/* © CNES */
import { Control } from 'ol/control';
import { useCallback, useContext, useEffect } from 'react';
import { ConfigContext } from '../../../../context/ConfigContext';
import MapContext from '../../MapContext';
import './FullScreenControl.scss';

/**
 * Full Screen Control.
 * @returns null
 */
const FullScreenControl = () => {
  const { map } = useContext(MapContext);
  const context = useContext(ConfigContext);

  const toggleFullscreen = useCallback(() => {
    context.setBothPanelVisibility(
      !context.isLeftSidePanelShown,
      !context.isRightSidePanelShown
    );
  }, [context]);

  /**
   * display options to activate full screen on map.
   */
  useEffect(() => {
    if (!map) return;
    const button = document.createElement('button');
    button.id = 'fullscreen-button';
    const element = document.createElement('div');
    element.id = 'toggle-fullscreen';
    element.className = 'toggle-fullscreen ol-unselectable ol-control';

    if (context.isLeftSidePanelShown) {
      button.innerHTML = `<svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 10L21 3M21 3H15M21 3V9M10 14L3 21M3 21H9M3 21L3 15" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;
      element.className = 'toggle-halfscreen ol-unselectable ol-control';
      button.title = 'Hide panels';
    } else {
      button.innerHTML = `<svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 14H10M10 14V20M10 14L3 21M20 10H14M14 10V4M14 10L21 3" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      `;
      button.title = 'Show panels';
    }

    element.appendChild(button);
    button.addEventListener('click', toggleFullscreen, false);
    const customControl = new Control({ element });
    map.addControl(customControl);

    return () => {
      map.removeControl(customControl);
    };
  }, [map, toggleFullscreen, context]);
  return null;
};
export default FullScreenControl;
